export default "__VITE_ASSET__dd603d2c__"